import { useThreadsLogin, UseThreadsLoginConfig } from '@sparemin/auth';
import { useDispatch, useSelector } from 'react-redux';
import { pick } from 'underscore';
import { getSocialProfile } from 'redux/middleware/api/third-party-authentication-service/actions';
import { tokenSelector } from 'redux/modules/auth';
import {
  clearThreadsUser,
  getThreadsUser,
  threadsAuthorizeSuccess,
} from 'redux/modules/social';
import { Dispatch } from 'redux/types';
import { SocialSharePlatform } from 'types';
import { FatalError } from 'utils/FatalError';

export interface UseThreadsAuthenticatorConfig
  extends Pick<UseThreadsLoginConfig, 'force'> {
  onAuthSuccess?: () => void;
  onError?: (error: Error) => void;
}

export default function useThreadsAuthenticator({
  force,
  onAuthSuccess,
  onError,
}: UseThreadsAuthenticatorConfig) {
  const spareminToken = useSelector(tokenSelector);

  const dispatch = useDispatch<Dispatch>();

  return useThreadsLogin({
    force,
    spareminToken,
    onSuccess: async data => {
      dispatch(clearThreadsUser());

      if (data) {
        dispatch(
          threadsAuthorizeSuccess(
            pick(data.tokenInfo, 'accessToken', 'idToken', 'providerUserId'),
          ),
        );
      }

      try {
        const { accessToken, providerUserId, idToken } = data.tokenInfo;

        const { response } = await dispatch(
          getSocialProfile(
            SocialSharePlatform.THREADS,
            providerUserId,
            idToken,
            accessToken,
          ),
        );

        await dispatch(getThreadsUser(response));

        onAuthSuccess?.();
      } catch (error) {
        throw new FatalError(error.message);
      }
    },
    onError,
  });
}
